<template>
  <div class="fuselage">
      <div class="nose">
          <span class="nose-topic" style="display: flex;align-items: center;justify-content: space-between;">
  					我是实用的计算器
            <img src="../assets/img/closewin.png" width="24" height="24" style="cursor: pointer;" @click="handleClose" />
  				</span>
          <br>
      </div>
      <input type="text" name="cc" id="cc" value="0" disabled="true" v-model="result">
      <div class="key">
          <ul>
              <li @click="run(7)">7</li>
              <li @click="run(8)">8</li>
              <li @click="run(9)">9</li>
              <li @click="del()">←</li>
              <li @click="clearscreen()">C</li>
              <li @click="run(4)">4</li>
              <li @click="run(5)">5</li>
              <li @click="run(6)">6</li>
              <li @click="times()">×</li>
              <li @click="divide()">÷</li>
              <li @click="run(1)">1</li>
              <li @click="run(2)">2</li>
              <li @click="run(3)">3</li>
              <li @click="plus()">+</li>
              <li @click="minus()">-</li>
              <li @click="run(0)">0</li>
              <li @click="dzero()">00</li>
              <li @click="dot()">.</li>
              <li @click="persent()">%</li>
              <li @click="equal()">=</li>
          </ul>
      </div>
  </div>
</template>

<script>
  var num = 0,
      result = 0,
      numshow = "0";
  var operate = 0; //判断输入状态的标志
  var calcul = 0; //判断计算状态的标志
  var quit = 0; //防止重复按键的标志
  export default {
    name: 'Footer',
    components:{

    },
    data () {
      return {
        result:null,

      }
    },
    methods:{
      handleClose(){
        console.log(1)
        this.$emit('handleClose')
      },
      run(num) {
          var c = document.getElementById("cc").value;
          c = (c != "0") ? ((operate == 0) ? c : "") : "";
          c = c + num;
          this.result = c;
          operate = 0; //重置输入状态
          quit = 0; //重置防止重复按键的标志
      },
      dzero() {
          var c = document.getElementById("cc").value;
          c = (c != "0") ? ((operate == 0) ? c + "00" : "0") : "0"; //如果当前值不是"0"，且状态为0，则返回当str+"00"，否则返回"0";
          document.getElementById("cc").value = c;
          operate = 0;
      },
      dot() {
          var c = document.getElementById("cc").value;
          c = (c != "0") ? ((operate == 0) ? c : "0") : "0"; //如果当前值不是"0"，且状态为0，则返回当前值，否则返回"0";
          for (var i = 0; i <= c.length; i++) { //判断是否已经有一个点号
              if (c.substr(i, 1) == ".")
                  return false; //如果有则不再插入
          }
          c = c + ".";
          document.getElementById("cc").value = c;
          operate = 0;
      },
      del() { //退格
          var c = document.getElementById("cc").value;
          c = (c != "0") ? c : "";
          c = c.substring(0, c.length - 1);
          c = (c != "") ? c : "0";
          document.getElementById("cc").value = c;
      },
      clearscreen() { //清除数据
          num = 0;
          result = 0;
          numshow = "0";
          document.getElementById("cc").value = "0";
      },
      plus() { //加法
          this.calculate(); //调用计算函数
          operate = 1; //更改输入状态
          calcul = 1; //更改计算状态为加
      },
      minus() { //减法
          this.calculate(); //调用计算函数
          operate = 1;
          calcul = 2;
      },
      times() { //乘法
          this.calculate(); //调用计算函数
          operate = 1;
          calcul = 3;
      },
      divide() { //除法
          this.calculate(); //调用计算函数
          operate = 1;
          calcul = 4;
      },
      persent() { //求余
          this.calculate(); //调用计算函数
          operate = 1;
          calcul = 5;
      },
      equal() {
          this.calculate(); //调用计算函数
          operate = 1;
          num = 0;
          result = 0;
          numshow = "0";
      },
      calculate() {
          numshow = Number(document.getElementById("cc").value);
          if (num != 0 && quit != 1) { //判断前一个运算数是否为零以及防重复按键的状态
              switch (calcul) { //判断要输入状态
                  case 1:
                      result = num + numshow;
                      break; //计算"+"
                  case 2:
                      result = num - numshow;
                      break; //计算"-"
                  case 3:
                      result = num * numshow;
                      break;
                  case 4:
                      if (numshow != "0") {
                          result = num / numshow;
                      } else {
                          var xjx = '被除数不能为零！'
                          document.getElementById("cc").value = xjx;
                          setTimeout(clearnote, 4000)
                      }
                      break;
                  case 5:
                      result = num % numshow;
                      break;
              }
              quit = 1; //避免重复按键
          } else {
              result = numshow;
          }
          numshow = String(result);
          document.getElementById("cc").value = numshow;
          num = result; //存储当前值
      },
      clearnote() { //清空提示
          document.getElementById("cc").value = "";
      }
    },
    created(){

    }
  }
</script>

<style scoped="">
  body {
  	background-color:gainsboro;
  }
  .fuselage {
  	border-radius:20px;
  	border:white solid 1.5px;
  	width:400px;
  	height:500px;
  	background-color:#EAEAEA;
  	margin:0 auto;
  }
  .nose {
  	height:50px;
  	display:block;
  	padding: 15px;
    justify-content: space-between;
  }
  .nose-topic {
  	color:rgba(0,0,0,0.8);
  	font-size:25px;
  }
  #cc {
  	text-align:right;
  	border-radius:10px;
  	margin:0 5px;
  	width:390px;
  	height:60px;
  	color:rgba(0,0,0,0.6);
  	background-color:#F2F2F2;
  	border:rgba(0,0,0,0.3) solid 2px;
  	font-size:40px;
  }
  .key ul {
  	background-color:white;
  	border-radius:10px;
  	padding:0;
  	margin:5px 14px;
  	border:#fff 2px solid;
  	height:350px;
  	overflow:hidden
  }
  .key li {
  	border-radius:10px;
  	list-style:none;
  	float:left;
  	width:46.5px;
  	height:72px;
  	margin:1px;
  	padding:9px 0px 4px 25px;
  	display:inline;
  	font-size:38px;
  	background-color:lightgray;
  }
  .key li:hover {
  	color:white;
  	border-radius:10px;
  	list-style:none;
  	float:left;
  	width:46.5px;
  	height:72px;
  	margin:1px;
  	padding:9px 0px 4px 25px;
  	display:inline;
  	font-size:38px;
  	background-color:rgba(0,0,0,0.5);
  }
  .key li:active {
  	color:white;
  	border-radius:10px;
  	list-style:none;
  	float:left;
  	width:46.5px;
  	height:72px;
  	margin:1px;
  	padding:9px 0px 4px 25px;
  	display:inline;
  	font-size:38px;
  	background-color:rgba(0,0,0,0.2);
  }

</style>



// WEBPACK FOOTER //
// src/components/compute.vue